/*
 * @Author: Teemo Ding
 * @Date: 2021-09-03 11:16:20
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-06-09 11:48:38
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/StatusTag/index.tsx
 */
import React from 'react';
import {
  IOrderStatus,
  TemplateStatus,
  SubscriptionOrderStatus,
} from '@/src/types/common/order';
import css from './css.module.less';
import { getI18nFromGeneral } from '@/src/tools/tools';

const StatusTag = (props) => {
  const { status, calculate, className } = props;
  const tagColor = {
    [IOrderStatus.ACTIVE]: {
      color: '#B7EB8F',
      backgroundColor: '#F6FFED',
      label: getI18nFromGeneral('general.status.active'),
    },
    [IOrderStatus.DRAFT]: {
      color: '#FFE58F',
      backgroundColor: '#FFFBE6',
      label: getI18nFromGeneral('general.status.draft'),
    },
    [IOrderStatus.SAVED]: {
      color: '#FFE58F',
      backgroundColor: '#FFFBE6',
      label: getI18nFromGeneral('general.status.saved'),
    },
    [IOrderStatus.COMPLETE]: {
      color: '#B9BCBF',
      backgroundColor: '#F4F5F7',
      label: getI18nFromGeneral('general.status.complete'),
    },
    [IOrderStatus.SUSPENDED]: {
      color: '#FFE58F',
      backgroundColor: '#FFFBE6',
      label: getI18nFromGeneral('general.status.suspended'),
    },
    [IOrderStatus.CANCELLED]: {
      color: '#FFA39E',
      backgroundColor: '#FFF1F0',
      label: getI18nFromGeneral('general.status.cancelled'),
    },
    [IOrderStatus.COMPLETED]: {
      color: '#5738C2',
      backgroundColor: 'rgba(87, 56, 194, 0.2)',
      label: getI18nFromGeneral('general.status.completed'),
    },
    [TemplateStatus.Active]: {
      color: '#B7EB8F',
      backgroundColor: '#F6FFED',
      label: getI18nFromGeneral('general.status.active'),
    },
    [TemplateStatus.Draft]: {
      color: '#FFE58F',
      backgroundColor: '#FFFBE6',
      label: getI18nFromGeneral('general.status.draft'),
    },
    [SubscriptionOrderStatus.Created]: {
      color: '#FFE58F',
      backgroundColor: '#FFFBE6',
    },
    [TemplateStatus.Locked]: {
      color: '#B9BCBF',
      backgroundColor: '#F4F5F7',
      label: getI18nFromGeneral('general.status.locked'),
    },
  };
  return status ? (
    <div
      className={`${className} ${css.statusTag}`}
      style={{
        ...(tagColor[status] || {
          color: '#1B93C5',
          backgroundColor: '#F4FCFF',
        }),
        border: `1px solid ${(tagColor[status] || {}).color || '#1B93C5'}`,
      }}>
      {calculate ? calculate[status] : tagColor[status].label}
    </div>
  ) : null;
};

export default StatusTag;
